export default interface UserAction {
    type: UserActionTypes,
    text: string,
    object_id : string
}

export enum UserActionTypes {
    EXPLOITATION = "EXPLOITATION",
}